<template>
  <div class="page scroll-wrapper">
    <header class="header py-2 px-4 flex items-center justify-between bg-white w-full box-border fixed top-0 z-10">
      <img src="@/assets/home/logo.svg" alt="">
    </header>
    <div class="navigation-container fixed z-20" :class="{'active': showMenu}" @click="showMenu = false">
      <nav class="navigation absolute flex flex-col items-center justify-center" @click.stop="() => false">
        <div class="nav-item my-2 pb-2.5 px-2 font-semibold" v-for="(item, index) in menu" :key="index"
             :class="{'current': menuIndex === index}"
             @click.stop="scrollToSec(item, index)">{{item.label }}</div>
      </nav>
      <img class="w-6 h-6 absolute top-4 right-4 z-10 pointer-events-auto"
           src="@/assets/phone/icon-menu.svg"
           @click.stop="showMenu = !showMenu">
    </div>
    <BannerPhone/>
<!--    <div class="banner">-->
<!--      <img v-lazy="require('@/assets/phone/banner-2.jpg')" class="h-full object-cover">-->
<!--    </div>-->
    <!--    首页-->
    <div id="home">
      <section id="home-sec-1" class="p-8">
        <h3 id="home-sec-1-title" class="section-title mb-8">中药材7S数字化产地仓</h3>
        <img id="home-sec-1-cover" class="cover from rounded-xl mb-6" v-lazy="require('@/assets/home/home-cover-1.png')">
        <ul id="home-sec-1-block-1" class="flex tag-list justify-between mb-8 from">
          <li class="flex flex-col items-center">
            <RedIcon icon="home-icon-1.svg" :size="48" :rounded="12"/>
            <div class="text-sm mt-4" style="color: #E84E4E;font-weight: 500;">规范化种植</div>
          </li>
          <li class="flex flex-col items-center">
            <RedIcon icon="home-icon-2.svg" :size="48" :rounded="12" />
            <div class="text-sm mt-4" style="color: #E84E4E;font-weight: 500;">集约化加工</div>
          </li>
          <li class="flex flex-col items-center">
            <RedIcon icon="home-icon-3.svg" :size="48" :rounded="12" />
            <div class="text-sm mt-4" style="color: #E84E4E;font-weight: 500;">电子化交易</div>
          </li>
        </ul>
        <p id="home-sec-1-block-2" class="text-desc text-xs leading-6 from">7S中药材产地仓，是以7S第三方质量控制与评价体系为依托，构建道地药材生产技术体系和质量控制体系，在道地药材产区，联合产区政府、企业，共同创新推出“七统一两集中”中药材产地仓公共服务模式，以实现高品质药材提质、稳供为目的。打造一批种植规范化、产品标准化生产基地，形成品种集群化的一站式供应服务，满足医保集采、经典名方生产、品牌中医馆、品牌连锁药店、智慧煎药中心、出口等企业对高品质药材的需要，实现中药材产业提质增效，以产业振兴推动乡村振兴。</p>
        <img id="home-sec-1-block-3" v-lazy="require('@/assets/home/home-cover-2.png')" class="my-6 from">
        <h3 id="home-sec-1-block-4" class="heading-1 text-center text-xs from"
            style="color: #898893;font-family: 'Alimama ShuHeiTi', Serif;">中药材 7S 数字化产地仓公共服务平台<br>(7S 产地仓数字化管理平台)架构图</h3>
      </section>
    </div>
    <!--    数字药园-->
    <div id="park">
      <section id="park-sec-1">
        <div class="pt-8 px-8">
          <h3 id="park-sec-1-title" class="section-title mb-10">数字药园</h3>
          <div id="park-sec-1-block-1" class="change-container w-full overflow-hidden from">
            <div class="change-scroll-list flex flex-nowrap transition ease-in-out duration-500"
                 :style="{transform: `translateX(${ currentParkIndex * -scrollWidth }px)`}">
              <div v-for="(item, index) in parkList" class="change-item flex-none opacity-0 transition duration-500 ease-in-out"
                   :class="{'opacity-100': currentParkIndex === index}"
                   :key="index" style="height: 300px;"
                   :style="{width: scrollWidth + 'px'}">
                <img :src="item.cover"
                     class="w-full h-full"
                     style="object-fit: contain;">
              </div>
            </div>
          </div>
        </div>
        <div id="park-sec-1-block-2" class="scroll-container overflow-x-hidden py-8 from"
             @touchstart="handleParkTouch"
             @touchend="handleParkTouch">
          <ul class="park-list flex flex-nowrap gap-4 px-8 transition duration-150" :style="{transform: `translateX(${currentParkIndex * -310}px)`}">
            <li v-for="(item, index) in parkList" :key="index" class="p-4 cursor-pointer flex-none box-border"
                style="width: 310px;box-shadow: 7px 5px 20px rgba(0, 0, 0, 0.1);border-radius: 8px;">
              <h4 class="mb-4 text-base">{{ item.title }}</h4>
              <p class="text-desc text-xs leading-8">{{ item.desc }}</p>
            </li>
          </ul>
        </div>
      </section>
      <section id="park-sec-2" class="p-8">
        <h3 id="park-sec-2-title" class="section-title mb-10">数字药园-数字基地全景图</h3>
        <img id="park-sec-2-block-1" v-lazy="require('@/assets/home/park-cover-1.png')" class="from">
      </section>
      <section id="park-sec-3" class="p-8">
        <h3 id="park-sec-3-title" class="section-title mb-10">数字药园—中药材全产业链溯源</h3>
        <p id="park-sec-3-block-1" class="text-desc text-xs leading-8 from">“中药追溯”中药材全产业链区块链溯源采用区块链技术为中药材建立“身份证”制度，向前延申到原料供应商的种植基地，向后延展到加工产品销售，动态采集基于区块链的覆盖种植、农作、采摘、包装、仓储、运输、产地加工、流通、收储、精深加工、流通、销售等全产业链的溯源信息，溯源信息经7S质控审核后，上链发布。</p>
        <img id="park-sec-3-block-2" v-lazy="require('@/assets/home/park-cover-2.png')" class="from">
      </section>
    </div>
    <!--    数字工厂-->
    <div id="factory">
      <section id="factory-sec-1" class="p-8">
        <h3 id="factory-sec-1-title" class="section-title mb-8">数字工厂</h3>
        <div id="factory-sec-1-block-1" class="from pb-6">
          <Macbook>
            <CuzSwiper :swiperPages="factorySwiperPages"/>
          </Macbook>
        </div>
        <ul id="factory-sec-1-block-2" class="factory-list from">
          <li v-for="(item, index) in factoryList" :key="index" class="py-4">
            <div class="flex mb-4 items-center">
              <img :src="item.icon" class="w-8 h-8">
              <h4 class="ml-2.5">{{item.title}}</h4>
            </div>
            <p class="text-desc text-xs leading-7">{{item.desc}}</p>
          </li>
        </ul>
      </section>
    </div>
    <!--    数字交易-->
    <div id="trade">
      <section id="trade-sec-1" class="p-8">
        <h3 class="section-title">数字交易</h3>
        <p id="trade-sec-1-block-1" class="text-desc text-xs leading-8 my-8 from">建立数字化交易平台，集群千乡万社数字化产地仓的标准化产品，开展订药园和中药材集采集供的电子化交易服务，为国家医保联采提供保障质量的药材原料，同时满足中药企业、医馆、连锁药店、煎药中心、出口等企业对高品质药材的集采需要，实现产销一体化。</p>
        <img id="trade-sec-1-block-2" v-lazy="require('@/assets/home/trade-cover-1.png')" class="from">
      </section>
      <section id="trade-sec-2">
        <div class="p-8">
          <h3 class="section-title mb-8">数字交易-中药材数字交易平台</h3>
          <p id="trade-sec-2-block-1" class="text-desc text-xs leading-7 from">中药材数字交易平台是面向中药材产业链上的种植、流通、加工等环节用户，以“统一标准、统一植保、统一加工、统一检测、统一认证、统一溯源、统一包装、集中仓储、集中供应”的“七统一两集中”创新管理 模式，构建中药原料贸易服务的S2B电子商务平台。解决交易模式落后、交易形式传统、交易信息闭塞、 交易数据缺失等问题，通过整合中药材种植、加工、检测、仓储、物流、交易等环节，降低中药材产业链运营成本，助力中药材产业高质量发展。</p>
          <div id="trade-sec-2-block-2" class="flex flex-col w-full items-center justify-center from">
            <div class="change-container w-full overflow-hidden">
              <div class="change-scroll-list flex flex-nowrap transition ease-in-out duration-500"
                   :style="{transform: `translateX(${ tradeSwiperIndex * -scrollWidth }px)`}">
                <div v-for="(item, index) in tradeSwiperList" class="change-item flex-none opacity-0 transition duration-500 ease-in-out"
                     :class="{'opacity-100': tradeSwiperIndex === index}"
                     :key="index" style="height: 300px;"
                     :style="{width: scrollWidth + 'px'}">
                  <img v-lazy="item.cover"
                       class="w-full h-full"
                       style="object-fit: contain;">
                </div>
              </div>
            </div>
            <div class="flex mt-8 tab">
              <div v-for="(item, index) in tradeSwiperList" :key="index"
                   class="px-4 py-2.5 bg-white rounded-full mr-4 cursor-pointer text-xs tab-item"
                   :class="{'current': tradeSwiperIndex === index}"
                   @click="tradeSwiperIndex = index">{{ item.title }}</div>
            </div>
          </div>
        </div>
        <div id="trade-sec-2-block-3" class="scroll-container overflow-x-hidden py-8 from"
             @touchstart="handleTradeTouch"
             @touchend="handleTradeTouch">
          <ul class="park-list flex flex-nowrap gap-4 px-8 transition duration-150"
              :style="{transform: `translateX(${tradeTouchCtrl.currentIndex * -300}px)`}">
            <li style="width: 300px;box-shadow: 7px 5px 20px rgba(0, 0, 0, 0.1);border-radius: 8px;" class="flex-none p-4 shadow">
              <h4 class="heading-2 mb-4 text-sm font-semibold"><span style="color: #E84E4E;">线上：</span>建设中药材交易数字产业平台 <br><span style="color: #E93619;">（包括4大系统）</span></h4>
              <ul>
                <li class="flex bg-white p-4 items-center" v-for="(item, index) in tradeList[0]" :key="index">
                  <img class="w-6 h-6" :src="item.icon" alt="">
                  <div class="pl-2 text-xs">
                    <h5 class="font-semibold" style="color: #2B2A3D;">{{item.title}}</h5>
                    <p class="text-desc">{{item.desc}}</p>
                  </div>
                </li>
              </ul>
            </li>
            <li style="width: 300px;box-shadow: 7px 5px 20px rgba(0, 0, 0, 0.1);border-radius: 8px;" class="flex-none p-4 shadow ml-4">
              <h4 class="heading-2 mb-4 text-sm font-semibold"><span style="color: #E84E4E;">线下：</span>建设<span style="color: #E93619;">2个</span>设配套设施</h4>
              <ul class="flex gap-3 flex-wrap">
                <li class="flex bg-white p-4 items-center" v-for="(item, index) in tradeList[1]" :key="index">
                  <img class="w-6 h-6" :src="item.icon" alt="">
                  <div class="pl-2 text-xs">
                    <h5 class="font-semibold" style="color: #2B2A3D;">{{item.title}}</h5>
                    <p class="text-desc">{{item.desc}}</p>
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </section>
    </div>
    <!--    数字金融-->
    <div id="finance">
      <section id="finance-sec-1" class="p-8">
        <h3 class="section-title mb-8">数字金融</h3>
        <ul id="finance-sec-1-block-1" class="from">
          <li v-for="(item, index) in financeList" :key="index" class="py-4">
            <div class="flex items-center mb-4">
              <img :src="item.icon" class="w-8 h-8">
              <h4 class="font-semibold pl-2">{{ item.title }}</h4>
            </div>
            <p class="text-xs text-desc leading-7">{{ item.desc }}</p>
          </li>
        </ul>
        <div id="finance-sec-1-block-2" class="flex flex-col w-full items-center justify-center from">
          <div class="change-container w-full overflow-hidden">
            <div class="change-scroll-list flex flex-nowrap transition ease-in-out duration-500"
                 :style="{transform: `translateX(${ financeSwiperIndex * -scrollWidth }px)`}">
              <div v-for="(item, index) in financeSwiperList" class="change-item flex-none opacity-0 transition duration-500 ease-in-out"
                   :class="{'opacity-100': financeSwiperIndex === index}"
                   :key="index" style="height: 300px;"
                   :style="{width: scrollWidth + 'px'}">
                <img v-lazy="item.cover"
                     class="w-full h-full"
                     style="object-fit: contain;">
              </div>
            </div>
          </div>
          <div class="flex mt-8 tab">
            <div v-for="(item, index) in financeSwiperList" :key="index"
                 class="px-4 py-2.5 bg-white rounded-full mr-4 cursor-pointer text-xs tab-item"
                 :class="{'current': financeSwiperIndex === index}"
                 @click="financeSwiperIndex = index">{{ item.title }}</div>
          </div>
        </div>
      </section>
    </div>
    <!--    数字监控-->
    <div id="monitor">
      <section id="monitor-sec-1" class="p-8">
        <h3 class="section-title mb-8">数字监管</h3>
        <div id="monitor-sec-1-block-1" class="from">
          <div id="factory-sec-1-block-1" class="from pb-6">
            <Macbook>
              <CuzSwiper :swiperPages="monitorSwiperPages"/>
            </Macbook>
          </div>
          <h4 class="mt-2.5 mb-6 text-sm" style="font-family: 'Alimama ShuHeiTi', Serif;color: #E93619;">中药材产业资源一幅图，中药材产业互联一张网</h4>
        </div>
        <ul id="monitor-sec-1-block-2" class="from">
          <li v-for="(item, index) in monitorList" :key="index" class="py-4">
            <h5 class="mb-2 text-base font-semibold">{{ item.title }}</h5>
            <p class="text-desc text-xs leading-7">{{ item.desc }}</p>
          </li>
        </ul>
      </section>
    </div>
    <!--产业大数据-->
    <div id="data">
      <section id="data-sec-1" class="p-8">
        <h3 class="section-title mb-8">产业大数据及服务平台</h3>
        <p id="data-sec-1-block-1" class="text-desc text-xs leading-7 my-8 from">集群千乡万社数字化产地仓的标准化产品，开展订药园和中药材集采集供的电子化交易服务，为国家医保联采提供保障质量的药材原料，同时满足中药企业、医馆、连锁药店、煎药中心、出口等企业对高品质药材的集采需要，实现产销一体化。</p>
        <img id="data-sec-1-block-2" v-lazy="require('@/assets/home/data-cover-1.png')" class="from">
      </section>
    </div>
    <!--    关于我们-->
    <div id="about">
      <section id="about-sec-1" class="p-8">
        <h3 class="section-title">关于我们</h3>
        <p id="about-sec-1-block-1" class="text-desc text-xs leading-7 my-6 from">7S产地仓数字化管理平台，是为了积极服务中国中药协会和中国乡村发展协会联合发起“千乡万社中药材科技兴农计划”，推动在道地药材主产区建设科技领先、功能完善、与市场联结紧密的中药材数字化产地仓项目，运用区块链、云计算和大数据等信息技术与7S体系整合创新形成，集数字药园、数字工厂、数字金融、数字交易、数字监管、产业大数据于一体，是中药材产业的数字新基建，满足药农、合作社、种植企业、加工企业、交易中心、政府等主体的数字管理和运营，应用数字化技术对产业链的生产、质控、物流、金融、营销等进行数字赋能，推进中药材标准化生产和数字化协同。<br>通过从整个产业链角度的资源整合和价值链优化，降低整个产业的运营成本，提高整个产业的运营质量与效率，促进中药材产业的供给侧结构性改革，带动产业链整体转型升级。</p>
        <img id="about-sec-1-block-2" v-lazy="require('@/assets/home/about-cover-1.png')" class="from">
      </section>
      <section id="about-sec-2" class="p-8">
        <h3 class="section-title mb-8">关于我们-7S中药材产地仓业务模式</h3>
        <img id="about-sec-2-block-1" v-lazy="require('@/assets/home/about-cover-2.png')" class="w-full from">
      </section>
      <section id="about-sec-3" class="p-8">
        <h3 class="section-title mb-8">关于我们-合作单位</h3>
        <ul id="about-sec-3-block-1" class="department-list relative from">
          <li v-for="(item, index) in departmentList" :key="index"
              class="bg-white transition-all cursor-pointer flex-1 flex flex-col py-4">
            <div class="flex items-center">
              <img :src="item.icon" class="w-8 h-8">
              <div class="pl-2 title font-semibold my-4">{{ item.title }}</div>
            </div>
            <div class="departments">
              <div class="department text-xs leading-6"
                   style="color: #898893;"
                   v-for="(department, departmentIndex) in item.departments" :key="departmentIndex">{{department}}</div>
            </div>
          </li>
        </ul>
      </section>
    </div>
<!--    <footer class="footer text-center box-border text-xs  leading-6" style="color: #898893;">-->
<!--      <div>备案编号: 蜀ICP备15009849号-2</div>-->
<!--    </footer>-->
    <FormModalPhone />
  </div>
</template>

<script>
import Macbook from "./Macbook.vue";
import RedIcon from "./RedIcon.vue";
import CuzSwiper from "./CuzSwiper.vue";
import FormModalPhone from "./FormModalPhone.vue";
import {isEmpty} from "lodash";
import BannerPhone from "./BannerPhone.vue";

function animationBase(parentName, children = ['title', 'cover', 'desc']) {
  children.forEach(child => {
    const target = document.querySelector(`#${parentName}-${child}`);
    if(!isEmpty(target)) {
      target.classList.remove('from');
    }
  })
}

export default {
  components: {BannerPhone, CuzSwiper, RedIcon, Macbook, FormModalPhone},
  data() {
    return  {
      menu: [
        {
          label: '首页',
          id: '',
        },
        {
          label: '数字药园',
          id: 'park',
        },
        {
          label: '数字工厂',
          id: 'factory',
        },
        {
          label: '数字交易',
          id: 'trade',
        },
        {
          label: '数字金融',
          id: 'finance',
        },
        {
          label: '数字监控',
          id: 'monitor',
        },
        {
          label: '产业大数据',
          id: 'data',
        },
        {
          label: '关于我们',
          id: 'about',
        },
      ],
      menuIndex: 0,
      menuIndexLock: false,
      showMenu: false,
      scrollEL: null,
      currentParkIndex: 0,
      parkList: [
        {
          title: '中药材种植模型构建',
          desc: '首先基于7S体系多年的基础研究和应用，获得的大量基础数据，结合中药材长势、质量等产出数据，形成中药材的“生长模型”，再通过深化分析、优化，形成评估指标和算法模型，构建出中药材“种植模型”。',
          cover: require('@/assets/home/park-list-cover-1.png'),
        },
        {
          title: '中药材数字基地建设',
          desc: '通过3S（GPS、GIS和RS）、物联网、自动化技术，实现基地温光水肥土等生产要素的数字化；通过管理标准化，实现农事记录、投入品定时、定位、定量管理，以高新技术投入和科学管理换取对自然资源的最大节约和对农业产出的最大索取。',
          cover: require('@/assets/home/park-list-cover-2.png'),
        },
        {
          title: '中药材种植数字化管理',
          desc: '通过中药材种植数字化管理APP（管农事）和数字基地可视化管理（管基地）平台对中药材基地进行数字化管理。基于种植模型为基地管理人员提供种植预警和管护建议，实现种植基地的绿色标准化流程作业。',
          cover: require('@/assets/home/park-list-cover-1.png'),
        },
      ],
      factorySwiperPages: [
        {
          image: require('@/assets/home/factory-swiper-1.png')
        },
        {
          image: require('@/assets/home/factory-swiper-2.png')
        },
        {
          image: require('@/assets/home/factory-swiper-3.png')
        },
        {
          image: require('@/assets/home/factory-swiper-4.png')
        }
      ],
      monitorSwiperPages: [
        {
          image: require('@/assets/home/monitor-swiper-1.png')
        },
        // {
        //   image: require('@/assets/home/monitor-swiper-3.png')
        // },
        {
          image: require('@/assets/home/monitor-swiper-2.png')
        }
      ],
      factoryList: [
        {
          icon: require('@/assets/phone/factory-icon-1.svg'),
          title: '数字生产线',
          desc: '对产地趁鲜加工和产地精深加工的生产线的设备进行三维建模，并结合生产工艺对产品生产加工流程进行体系化呈现，对生产车间进行实时视频监控，对生产排产等关键指标进行数据统计和实时监控。',
        },
        {
          icon: require('@/assets/phone/factory-icon-2.svg'),
          title: '产品追溯实时监测',
          desc: '对加工产品进行实时监控，统计溯源产品数量、扫码追溯记录等详细数据，并结合企业的产品销售数据，对产品流向、销售热区等进行实时统计和分析，为企业产品销售、质量管控提供数智化管理手段。',
        }
      ],
      tradeSwiperIndex: 0,
      tradeSwiperList: [
        {
          title: '数字交易平台',
          cover: require('@/assets/home/trade-swiper-1.png'),
        },
        {
          title: '交易平台小程序',
          cover: require('@/assets/home/trade-swiper-2.png'),
        }
      ],
      tradeList: [
        [
          {
            icon: require('@/assets/home/trade-icon-1.svg'),
            title: '中药材数字交易系统',
            desc: 'B2B大宗电子交易',
          },
          {
            icon: require('@/assets/home/trade-icon-2.svg'),
            title: '中药材合同订单管理系统',
            desc: '订单、合同、结算',
          },
          {
            icon: require('@/assets/home/trade-icon-3.svg'),
            title: '中药材运营管理系统',
            desc: '追溯、检测、资金等服务和运营管理',
          },
          {
            icon: require('@/assets/home/trade-icon-4.svg'),
            title: '中药材数字仓储系统',
            desc: '仓储配送一体化',
          },
        ],
        [
          {
            icon: require('@/assets/home/trade-icon-5.svg'),
            title: '中药材交易服务中心',
            desc: '展示、交易、服务',
          },
          {
            icon: require('@/assets/home/trade-icon-6.svg'),
            title: '中药材交易数字监管仓',
            desc: '包装、仓储、配送',
          },
        ],
      ],
      financeList: [
        {
          icon: require('@/assets/phone/finance-icon-1.svg'),
          title: '数字监管仓',
          desc: '数字监管仓内安装环境监控、视频监控等物联网设备，对中药材进行标准化仓储管理并形成标准仓单，中药材仓单质押贷业务基于标准仓单开展，为抵押者提供融资服务。'
        },
        {
          icon: require('@/assets/phone/finance-icon-2.svg'),
          title: '中药材仓单质押贷款',
          desc: '中药材仓单质押贷款是一种短期融资业务，中药材产业经营主体可以用中药材干品（如三七剪口、三七统货等）质押来获得贷款的一种方式。'
        },
      ],
      financeSwiperIndex: 0,
      financeSwiperList: [
        {
          title: '数字监管仓',
          cover: require('@/assets/home/finance-swiper-1.png'),
        },
        {
          title: '中药材仓单质押贷',
          cover: require('@/assets/home/finance-swiper-2.png'),
        }
      ],
      monitorList: [
        {
          title: '中药材产业数据可视化平台',
          desc: '通过在地图上进行定位和展示的方式，打破时间、空间的限制，多方位、多角度、多维度地可视化展示中药材产业发展情况，构建“中药材产业资源一幅图”集成展示新平台，增强道地药材的知名度。',
        },
        {
          title: '中药材数字化监管平台',
          desc: '建立较为完善的数字化管理机制和运行机制，针对中药材标准化生产、产品溯源、农业投入品、产地加工、销售等环节进行重点监管。',
        },
        {
          title: '中药材产业服务平台',
          desc: '以共享经济模式汇聚科技、物流、金融、营销等产业服务资源，对全产业链企业进行数字赋能，围绕中药材绿色标准化生产，提供重点品种价格监测，中药材产业内参等中药材资讯服务，提供产地趁鲜加工、产地精深加工、中药材专用农资、中药材仓单质押贷等中药材产地服务，形成“中药材产业互联一张网”带动产业链整体转型升级。实现种植基地的绿色标准化流程作业。',
        },
      ],
      departmentList: [
        {
          icon: require('@/assets/phone/about-icon-1.svg'),
          title: '组织机构',
          departments: [
            '现代中药资源动态监测信息和技术服务中心',
            '中国中药协会中药材检测认证技术专业委员会'
          ]
        },
        {
          icon: require('@/assets/phone/about-icon-2.svg'),
          title: '支持单位',
          departments: [
            '中国中药协会',
            '中国中医科学院中药资源中心',
            '中国药用植物研究所',
            '国家认监委认证认可技术研究所',
            '成都中医药大学',
            '解放军302医院全军中医药研究所',
            '中健安检测认证中心',
          ]
        },
        {
          icon: require('@/assets/phone/about-icon-3.svg'),
          title: '技术服务',
          departments: [
            '7S技术服务中心',
            '四川华邑检测认证服务有限公司',
            '云南唯恒基业科技有限公司',
          ]
        },
      ],
      parkTouchCtrl: {
        startX: 0,
      },
      tradeTouchCtrl: {
        startX: 0,
        currentIndex: 0,
      },
      scrollWidth: 300,
    }
  },
  methods: {
    scrollToSec({id}, index) {
      this.menuIndexLock = true;
      this.menuIndex = index;
      this.showMenu = false;
      let top = 0
      if(!isEmpty(id)){
        const target = document.querySelector(`#${id}`)
        top = target.offsetTop - 56
      }
      window.scrollTo({
        top,
        behavior: 'smooth'
      })
      setTimeout(() => {
        this.menuIndexLock = false;
      }, 1000)
    },
    openForm() {
      alert(1)
    },
    handleParkTouch(e) {
      switch (e.type) {
        case 'touchstart': {
          const { touches } = e;
          this.parkTouchCtrl.startX = touches[0].clientX;
          break;
        }
        case 'touchend': {
          const { changedTouches } = e;
          if(Math.abs(changedTouches[0].clientX - this.parkTouchCtrl.startX) > 30) {
            if(changedTouches[0].clientX > this.parkTouchCtrl.startX) {
              this.currentParkIndex = this.currentParkIndex > 0 ? this.currentParkIndex - 1 : 0
            }
            if(changedTouches[0].clientX < this.parkTouchCtrl.startX) {
              this.currentParkIndex = this.currentParkIndex < (this.parkList.length - 1) ? this.currentParkIndex + 1 : this.parkList.length - 1
            }
          }
          break;
        }
      }
    },
    handleTradeTouch(e) {
      switch (e.type) {
        case 'touchstart': {
          const { touches } = e;
          this.tradeTouchCtrl.startX = touches[0].clientX;
          break;
        }
        case 'touchend': {
          const { changedTouches } = e;
          if(Math.abs(changedTouches[0].clientX - this.tradeTouchCtrl.startX) > 30) {
            if(changedTouches[0].clientX > this.tradeTouchCtrl.startX) {
              this.tradeTouchCtrl.currentIndex = this.tradeTouchCtrl.currentIndex > 0 ? this.tradeTouchCtrl.currentIndex - 1 : 0
            }
            if(changedTouches[0].clientX < this.tradeTouchCtrl.startX) {
              this.tradeTouchCtrl.currentIndex = this.tradeTouchCtrl.currentIndex < (this.tradeList.length - 1) ? this.tradeTouchCtrl.currentIndex + 1 : this.tradeList.length - 1
            }
          }
          break;
        }
      }
    },
    sceneBuilder(trigger, menuIndex, children) {
      const scene = this.$scrollmagic.scene({
        triggerElement: `#${trigger}`,
      })
        .on('start', () => {
          animationBase(trigger, children);
          if(!this.menuIndexLock) {
            this.menuIndex = menuIndex;
          }
        })
      // if(process.env.NODE_ENV === 'development') {
      //   scene.addIndicators({
      //     name: trigger
      //   });
      // }
      this.$scrollmagic.addScene(scene);
    },
    sceneAbout() {
      this.sceneBuilder('about-sec-1', 7, ['block-1', 'block-2']);
      this.sceneBuilder('about-sec-2', 7, ['block-1']);
      this.sceneBuilder('about-sec-3', 7, ['block-1']);
    },
    sceneMonitor() {
      this.sceneBuilder('monitor-sec-1', 5, ['block-1', 'block-2', 'block-3']);
    },
    sceneData() {
      this.sceneBuilder('data-sec-1', 6, ['block-1', 'block-2']);
    },
    sceneFinance() {
      this.sceneBuilder('finance-sec-1', 4, ['block-1', 'block-2']);
    },
    sceneTrade() {
      this.sceneBuilder('trade-sec-1', 3, ['block-1', 'block-2']);
      this.sceneBuilder('trade-sec-2', 3, ['block-1', 'block-2', 'block-3']);
    },
    sceneFactory() {
      this.sceneBuilder('factory-sec-1', 2, ['block-1', 'block-2', 'block-3']);
    },
    scenePark() {
      this.sceneBuilder('park-sec-1', 1, ['block-1', 'block-2']);
      this.sceneBuilder('park-sec-2', 1, ['block-1']);
      this.sceneBuilder('park-sec-3', 1, ['block-1', 'block-2']);
    },
    sceneHome() {
      this.sceneBuilder('home-sec-1', 0, ['block-1', 'block-2', 'block-3', 'block-4', 'cover']);
    },
    init() {
      this.$scrollmagic.attachTo(document.querySelector('.scroll-wrapper'), {});
      this.sceneHome();
      this.scenePark();
      this.sceneFactory();
      this.sceneTrade();
      this.sceneFinance();
      this.sceneData();
      this.sceneMonitor();
      this.sceneAbout();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      this.scrollWidth = document.querySelector('#home-sec-1-title').offsetWidth;
    })
  }
}
</script>

<style lang="scss" scoped>
.page{
  padding-top: 56px;
  background: #EEEEEE;
  padding-bottom: 100px;
}
.header{
  height: 56px;
  img{
    height: 40px;
  }
}
.navigation-container{
  width: 100vw;
  height: 100vh;
  top: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0);
  overflow-x: hidden;
  transition: .15s ease;
  pointer-events: none;
  &.active{
    pointer-events: auto;
    background-color: rgba(0, 0, 0, 0.55);
    .navigation{
      transform: translateX(0);
    }
  }
  .navigation{
    transition: .15s ease;
    transform: translateX(100%);
    background-color: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(4px);
    width: 50%;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1;
    .nav-item{
      color: #666666;
      transition: all .15s;
      position: relative;
      border-bottom: 2px transparent solid;
      &.current{
        color: #E84E4E;
        border-bottom: 2px #E84E4E solid;
      }
    }
  }
}
.footer{

}
.tab{
  .tab-item{
    &.current{
      box-shadow: 7px 11px 43px rgba(0, 0, 0, 0.1);
      color: #E84E4E;
    }
  }
}
section{
  background-color: white;
  margin-bottom: 16px;
  overflow: hidden;
  .section-title{
    font-family: "Alimama ShuHeiTi",Serif;
    &:after{
      content: '';
      display: block;
      width: 32px;
      height: 4px;
      background: #E84E4E;
      margin-top: 10px;
    }
  }
}
.cooperate-button{
  background-color: #E84E4E;
}
#home{
  #home-sec-1{
    &-cover {
      transition: .5s ease;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
    &-block-1{
      transition: .5s ease .3s;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
    &-block-2{
      transition: .5s ease .5s;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
    &-block-3{
      transition: .5s ease .7s;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
    &-block-4{
      transition: .5s ease 1s;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
  }
}
#park{
  #park-sec-1{
    &-title{
      transition: .5s ease;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
    &-block-1{
      transition: .5s ease .3s;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
    &-block-2{
      transition: .5s ease .5s;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
  }
  #park-sec-2{
    &-block-1{
      transition: .5s ease;
      will-change: opacity, transform;
      &.from{
        transform: scale(2);
        opacity: 0;
      }
    }
  }
  #park-sec-3{
    &-block-1{
      transition: .5s ease;
      will-change: opacity, transform;
      &.from{
        transform: translateX(-300px);
        opacity: 0;
      }
    }
    &-block-2{
      transition: .5s ease .3s;
      will-change: opacity, transform;
      &.from{
        transform: translateX(300px);
        opacity: 0;
      }
    }
  }
}
#factory{
  #factory-sec-1{
    &-block-1{
      transition: .5s ease .3s;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
    &-block-2{
      li{
        border-bottom: 1px solid #EEEEEE;
        will-change: opacity, transform;
        &:nth-child(1){
          transition: .5s ease .3s;
        }
        &:nth-child(2){
          transition: .5s ease .5s;
        }
      }
      &.from{
        li{
          transform: translateX(200px);
          opacity: 0;
        }
      }
    }
  }
}
#trade{
  #trade-sec-1{
    &-block-1{
      transition: .5s ease .3s;
      will-change: opacity, transform;
      &.from{
        transform: translateX(300px);
        opacity: 0;
      }
    }
    &-block-2{
      transition: .5s ease .5s;
      will-change: opacity, transform;
      &.from{
        transform: translateX(-300px);
        opacity: 0;
      }
    }
  }
  #trade-sec-2{
    &-block-1{
      transition: .5s ease .3s;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
    &-block-2{
      transition: .5s ease .5s;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
    &-block-3{
      transition: .5s ease .7s;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
  }
}
#finance{
  #finance-sec-1{
    &-block-1{
      transition: .5s ease .3s;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
      li{
        border-bottom: 1px solid #EEEEEE;
        &:last-child{
          border-bottom: unset;
        }
      }
    }
    &-block-2{
      transition: .5s ease .5s;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
  }
}
#data{
  #data-sec-1{
    &-block-1{
      transition: .5s ease .3s;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
    &-block-2{
      transition: .5s ease .5s;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
  }
}
#monitor{
  #monitor-sec-1{
    &-block-1{
      transition: .5s ease;
      will-change: opacity, transform;
      &.from{
        transform: translateX(300px);
        opacity: 0;
      }
    }
    &-block-2{
      li{
        border-bottom: 1px solid #EEEEEE;
        will-change: opacity, transform;
        &:nth-child(1){
          transition: .5s ease .3s;
        }
        &:nth-child(2){
          transition: .5s ease .5s;
        }
        &:nth-child(3){
          transition: .5s ease .7s;
          border-bottom: unset;
        }
      }
      &.from{
        li{
          transform: translateX(200px);
          opacity: 0;
        }
      }
    }
  }
}
#about{
  #about-sec-1{
    &-block-1{
      transition: .5s ease;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
    &-block-2{
      transition: .5s ease .3s;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
  }
  #about-sec-2{
    &-block-1{
      transition: .5s ease;
      will-change: opacity, transform;
      &.from{
        transform: translateX(-300px);
        opacity: 0;
      }
    }
  }
  #about-sec-3{
    &-block-1{
      li{
        border-bottom: 1px solid #EEEEEE;
        will-change: opacity, transform;
        &:nth-child(1){
          transition: .5s ease;
        }
        &:nth-child(2){
          transition: .5s ease .3s;
        }
        &:nth-child(3){
          transition: .5s ease .5s;
          border-bottom: unset;
        }
      }
      &.from{
        li{
          transform: translateX(200px);
          opacity: 0;
        }
      }
    }
  }
}
</style>
